import React from 'react';
import { toast } from 'react-toastify';
import { CheckIcon } from 'src/assets/dynamicSvg';
import { Poppins } from 'src/common';
import * as S from './SuccessToast.styles';

interface SuccessToastProps {
  title?: string;
  subtitle?: string;
}

const SuccessToastContent: React.FC<SuccessToastProps> = ({
  title = 'Item has been updated successfully!',
  subtitle,
}) => {
  return (
    <S.Div $center={!subtitle}>
      <div className="toast-icon">
        <CheckIcon color="statusGreen" style={{ width: 32, height: 32 }} />
      </div>
      <div className="toast-content">
        <Poppins weight={600}>{title}</Poppins>
        {subtitle && <span className="toast-subtitle">{subtitle}</span>}
      </div>
    </S.Div>
  );
};

export const showSuccessToast = (overrides?: SuccessToastProps) => {
  toast(<SuccessToastContent {...overrides} />, {
    type: 'success',
    icon: false,
  });
};

const PENDING_TOAST_KEY = 'pendingSuccessToast';

export const queueSuccessToast = (overrides: SuccessToastProps) => {
  localStorage.setItem(PENDING_TOAST_KEY, JSON.stringify(overrides));
};

export const flushPendingToast = () => {
  const raw = localStorage.getItem(PENDING_TOAST_KEY);
  if (raw) {
    localStorage.removeItem(PENDING_TOAST_KEY);
    try {
      showSuccessToast(JSON.parse(raw));
    } catch {
      // ignore malformed data
    }
  }
};
